export default [
    {
        title: 'CsSolicitudPreferencia',
        load: () => import('@/modules/CustomerService/SolicitudCita/components/SolicitudPreferencia.vue')
    }
];
